import React, { Component, Fragment } from 'react';
import { Grid, Form, Icon, Popup } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import { POWERSCHOOL_INTEGRATION_FORM_NAME } from 'Common/FormEnum';
import { TitledCard } from 'Components/';
import { InputField, CheckboxField } from 'Common/SemanticWrapper';
import SISFields from 'Common/SISFields';
import {
  PowerSchoolMapOptions,
  PowerSchoolFieldEnum,
  PowerSchoolMapConfig,
} from 'Common/Constants/SISIntegration';

class PowerSchoolConfigurationForm extends Component {
  static propTypes = {
    gradeOptions: PropTypes.array.isRequired,
    siteOptions: PropTypes.array.isRequired,
    languageOptions: PropTypes.array.isRequired,
    stepComplete: PropTypes.func,
  };

  static defaultProps = {
    stepComplete: () => {},
  };

  render() {
    const {
      loading,
      gradeOptions,
      siteOptions,
      languageOptions,
      teacherOptions,
    } = this.props;
    return (
      <Fragment>
        <Form name={POWERSCHOOL_INTEGRATION_FORM_NAME}>
          <TitledCard title={'Configuration'}>
            <Grid>
              <Grid.Column width={9}>
                <Grid.Row>
                  <label>
                    <React.Fragment>
                      Enable PowerSchool Nightly Import
                      <Popup
                        basic
                        trigger={
                          <Icon size="large" name="question circle outline" />
                        }
                        content={
                          <div>
                            You must run a "Manual Import" before the nightly
                            auto imports will run.
                          </div>
                        }
                      />
                    </React.Fragment>
                  </label>
                  <Field
                    name={PowerSchoolFieldEnum.Enabled}
                    component={CheckboxField}
                    disabled={loading}
                  />
                </Grid.Row>
                <Grid.Row>
                  <Field
                    name={PowerSchoolFieldEnum.BaseUrl}
                    component={InputField}
                    label={'Base URL'}
                    disabled={loading}
                  />
                </Grid.Row>
                <Grid.Row>
                  <Field
                    name={PowerSchoolFieldEnum.ClientId}
                    component={InputField}
                    label={'Client Id'}
                    disabled={loading}
                  />
                </Grid.Row>
                <Grid.Row>
                  <Field
                    name={PowerSchoolFieldEnum.ClientSecret}
                    component={InputField}
                    label={'Client Secret'}
                    disabled={loading}
                  />
                </Grid.Row>
              </Grid.Column>
            </Grid>
          </TitledCard>
          <TitledCard title={'Field Mapping'}>
            <SISFields
              integrationMapOptions={PowerSchoolMapOptions}
              integrationMapConfig={PowerSchoolMapConfig}
              integrationMapData={{
                [PowerSchoolFieldEnum.GradeMapping]: gradeOptions,
                [PowerSchoolFieldEnum.SiteMapping]: siteOptions,
                [PowerSchoolFieldEnum.LanguageMapping]: languageOptions,
                [PowerSchoolFieldEnum.TeacherMapping]: teacherOptions,
              }}
            />
          </TitledCard>
        </Form>
      </Fragment>
    );
  }
}

const validate = (values) => {
  const errors = {};
  if (!values[PowerSchoolFieldEnum.BaseUrl]) {
    errors[PowerSchoolFieldEnum.BaseUrl] = 'Required';
  }
  if (!values[PowerSchoolFieldEnum.ClientId]) {
    errors[PowerSchoolFieldEnum.ClientId] = 'Required';
  }
  if (!values[PowerSchoolFieldEnum.ClientSecret]) {
    errors[PowerSchoolFieldEnum.ClientSecret] = 'Required';
  }

  PowerSchoolMapOptions.forEach((i) => {
    if (!values[i.key]) {
      errors[i.key] = `Please select an option.`;
    }
  });
  return errors;
};

export default reduxForm({
  form: POWERSCHOOL_INTEGRATION_FORM_NAME,
  validate,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(withRouter(connect()(PowerSchoolConfigurationForm)));



// WEBPACK FOOTER //
// ./src/pages/powerschoolintegration/components/PowerSchoolConfigurationForm.js